import React from 'react';

const LineChartLegend = ({ label, backgroundColor }) => {
  return (
    <li className="line-chart-legend-list-item d-flex justify-content-start align-items-center">
      <span className="line-chart-legend-label-color" style={{ backgroundColor }}></span>
      <span className="line-chart-legend-label">{label}</span>
    </li>
  );
};

export default LineChartLegend;
